import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'
import colors from '../../configuration/colors'

const TheButton = styled.button`
  animation: none !important;

  &:focus {
    outline: none;
  }

  .disabled {
    transition: box-shadow 0.8s ease, background-color 0.2s linear;
    background: ${colors.rock};
    box-shadow: none;
    cursor: default;
    color: ${colors.rock};

    &:focus {
      box-shadow: none;
    }
  }
`

export const Loader = styled.div`
  animation: rotateLoader 1.5s infinite;
  height: 25px;
  width: 25px;
  position: absolute;
  top: calc(50% - 12.5px);
  left: calc(50% - 12.5px);

  &.hide {
    display: none;
  }

  &:before,
  &:after {
    border-radius: 50%;
    content: '';
    display: block;
    height: 10px;
    width: 10px;
  }

  &:before {
    animation: ball1Loader 1.5s infinite;
    background-color: ${colors.white};
    box-shadow: 15px 0 0 ${colors.white};
    margin-bottom: 5px;
  }

  &:after {
    animation: ball2Loader 1.5s infinite;
    background-color: ${colors.white};
    box-shadow: 15px 0 0 ${colors.white};
  }

  @keyframes rotateLoader {
    0% {
      -webkit-transform: rotate(0deg) scale(0.8);
      -moz-transform: rotate(0deg) scale(0.8);
    }
    50% {
      -webkit-transform: rotate(360deg) scale(1.2);
      -moz-transform: rotate(360deg) scale(1.2);
    }
    100% {
      -webkit-transform: rotate(720deg) scale(0.8);
      -moz-transform: rotate(720deg) scale(0.8);
    }
  }

  @keyframes ball1Loader {
    0% {
      box-shadow: 15px 0 0 ${colors.white};
    }
    50% {
      box-shadow: 0 0 0 ${colors.white};
      margin-bottom: 0;
      -webkit-transform: translate(7px, 7px);
      -moz-transform: translate(7px, 7px);
    }
    100% {
      box-shadow: 15px 0 0 ${colors.white};
      margin-bottom: 5px;
    }
  }

  @keyframes ball2Loader {
    0% {
      box-shadow: 15px 0 0 ${colors.white};
    }
    50% {
      box-shadow: 0 0 0 ${colors.white};
      margin-top: -10px;
      -webkit-transform: translate(7px, 7px);
      -moz-transform: translate(7px, 7px);
    }
    100% {
      box-shadow: 15px 0 0 ${colors.white};
      margin-top: 0;
    }
  }
`

const SubmitButton = ({
  onClick,
  id,
  style,
  className,
  ariaLabel,
  text,
  tabIndex,
  disabled
}) => {
  const [isRunningAnimation, setIsRunningAnimation] = useState(false)
  const theme = useTheme()

  const _onClick = async () => {
    if (!isRunningAnimation && onClick) {
      setIsRunningAnimation(true)

      const success = await onClick()

      // TODO: design never provided an error state
      if (success) {
        setTimeout(() => {
          setIsRunningAnimation(false)
        }, 1500)
      }
    }
  }

  return (
    <TheButton
      id={id}
      aria-label={ariaLabel || text}
      tabIndex={tabIndex}
      className={`quest-btn btn-a btn-a-${theme?.style} ${className} ${
        isRunningAnimation || disabled ? 'disabled' : ''
      }`}
      disabled={disabled}
      style={style}
      onClick={!isRunningAnimation ? _onClick : null}
      onKeyPress={!isRunningAnimation ? _onClick : null}
    >
      <span
        style={{
          visibility: isRunningAnimation ? 'hidden' : 'visible'
        }}
      >
        {text}
      </span>
      <Loader className={isRunningAnimation ? '' : 'hide'} />
    </TheButton>
  )
}

SubmitButton.defaultProps = {
  style: {
    position: 'relative'
  },
  tabIndex: '0'
}

SubmitButton.propTypes = {
  id: PropTypes.string,
  tabIndex: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default SubmitButton
